<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div v-show="stateArrow" id="leftBox" class="leftBox" style="width: 206px">
          <vue-draggable-resizable :min-width="160" @resizing="onResize" :max-width="400" :draggable="false"
            :handles="['mr']" :w="206" :parent="false">
            <el-scrollbar>
              <tree :isSearch="isSearch" @initFun="initQuery" @nodeClick="nodeClick"></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane :label="$t('VehicleManagement.unaccepted')" name="first">
                <Unaccepted ref='unaccept' @cellClick="cellClick"></Unaccepted>
              </el-tab-pane>
              <el-tab-pane :label="$t('VehicleManagement.repaired')" name="second">
                <Repaired ref='repair'></Repaired>
              </el-tab-pane>
              <el-tab-pane :label="$t('VehicleManagement.alreadyRepaired')" name="third">
                <AlreadyRepaired ref='alreadyRepair'></AlreadyRepaired>
              </el-tab-pane>
              <el-tab-pane :label="$t('VehicleManagement.closed')" name="four">
                <Closed ref='close'></Closed>
              </el-tab-pane>
            </el-tabs>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RepairManagement from "./RepairManagement.js";
export default RepairManagement;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
